import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import { computed, observable } from 'mobx';
var Workspace = (_class = /*#__PURE__*/function (_Model) {
  function Workspace() {
    var _this;
    _classCallCheck(this, Workspace);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Workspace, [].concat(args));
    _initializerDefineProperty(_this, "name", _descriptor, _this);
    _initializerDefineProperty(_this, "description", _descriptor2, _this);
    _initializerDefineProperty(_this, "slug", _descriptor3, _this);
    _initializerDefineProperty(_this, "classification", _descriptor4, _this);
    _initializerDefineProperty(_this, "branding", _descriptor5, _this);
    _initializerDefineProperty(_this, "domains", _descriptor6, _this);
    _initializerDefineProperty(_this, "config", _descriptor7, _this);
    _initializerDefineProperty(_this, "customMetadataFields", _descriptor8, _this);
    _initializerDefineProperty(_this, "isDomainMatchedWorkspace", _descriptor9, _this);
    return _this;
  }
  _inherits(Workspace, _Model);
  return _createClass(Workspace, [{
    key: "parse",
    value:
    /**
     * Parse the workspace.
     */
    function parse(attrs) {
      return _objectSpread(_objectSpread({}, attrs), {}, {
        customMetadataFields: attrs.custom_metadata_fields
      });
    }
  }, {
    key: "customMetafields",
    get: function get() {
      var metafields = this.customMetadataFields || {};
      return {
        memberMetadataFields: metafields.member_metadata_fields || []
      };
    }
  }, {
    key: "corporate",
    get: function get() {
      var branding = this.branding || {};
      return branding.corporate && branding.corporate.enabled;
    }
  }, {
    key: "isB2B2C",
    get: function get() {
      return this.classification === 'B2B2C';
    }
  }, {
    key: "features",
    get: function get() {
      var _cfg$mobile_web_confi, _cfg$mobile_web_confi2, _cfg$mobile_web_confi3, _cfg$mobile_web_confi4, _cfg$mobile_web_confi5, _cfg$mobile_web_confi6, _cfg$information_gath, _cfg$information_gath2, _cfg$rooms_config$ena, _cfg$rooms_config;
      var cfg = this.config || {};
      return {
        get billing() {
          var billing = cfg.billing || {};
          var enabled = billing.enabled || false;
          var couponsEnabled = enabled && billing['coupons.enabled'] || false;
          var couponsReferralEnabled = enabled && couponsEnabled && billing['coupons.referral.enabled'] || false;
          var teamsCreditEnabled = enabled && billing['teams.credit.enabled'] || false;
          var teamsCreditLimit = enabled && billing['teams.credit.enabled'] && billing['teams.credit.limit'] || 0;
          return {
            enabled: enabled,
            couponsEnabled: couponsEnabled,
            couponsReferral: {
              enabled: couponsReferralEnabled,
              amount: billing['coupons.referral.amount'] || 0
            },
            teamsCredit: {
              enabled: teamsCreditEnabled,
              limit: teamsCreditLimit
            }
          };
        },
        legendsBuilderConfig: {
          enabled: cfg.legends_builder_config && cfg.legends_builder_config.enabled || false
        },
        calendarConfig: {
          enabled: cfg.calendar_config && cfg.calendar_config.enabled !== undefined ? cfg.calendar_config.enabled : true
        },
        impersonation: {
          enabled: cfg.impersonation && cfg.impersonation.enabled || false
        },
        tos: {
          enabled: cfg.tos && cfg.tos.enabled || false,
          showOnLogin: cfg.tos && cfg.tos.show_on_login || false,
          hideOnCustomerPortal: cfg.tos && cfg.tos.hide_on_customer_portal || false,
          customTermsEnabled: cfg.tos && cfg.tos.custom_source !== undefined && cfg.tos.custom_source !== null || false
        },
        pp: {
          enabled: cfg.pp && cfg.pp.enabled || false
        },
        analyticsConfig: {
          enabled: cfg.analytics_config && cfg.analytics_config.enabled || false
        },
        jobConfig: {
          maxConcurrentProviderJobs: cfg.job_config && cfg.job_config.max_concurrent_provider_jobs || 0,
          providerCompletedJobAccess: cfg.job_config && cfg.job_config.provider_completed_job_access || 'NO_ACCESS',
          anonymousOpportunities: cfg.job_config && cfg.job_config.anonymous_opportunities || false,
          jobMuteTeamAdmins: cfg.job_config && cfg.job_config.job_mute_team_admins !== undefined ? cfg.job_config.job_mute_team_admins : true,
          jobHideClientTasks: cfg.job_config && cfg.job_config.job_hide_client_tasks !== undefined ? cfg.job_config.job_hide_client_tasks : false,
          jobHideProviderTasks: cfg.job_config && cfg.job_config.job_hide_provider_tasks !== undefined ? cfg.job_config.job_hide_provider_tasks : false
        },
        jobDetailsConfig: {
          simplifiedNavBar: {
            enabled: cfg.job_details_config && cfg.job_details_config['simplified_nav_bar.enabled'] || false,
            targetUrl: cfg.job_details_config && cfg.job_details_config['simplified_nav_bar.target_url'] || '',
            image: cfg.job_details_config && cfg.job_details_config['simplified_nav_bar.image'] || ''
          },
          tabConfig: {
            enabled: cfg.job_details_config && cfg.job_details_config['tab_config.enabled'] || false,
            details: cfg.job_details_config && cfg.job_details_config['tab_config.details'] !== undefined ? cfg.job_details_config['tab_config.details'] : true,
            events: cfg.job_details_config && cfg.job_details_config['tab_config.events'] !== undefined ? cfg.job_details_config['tab_config.events'] : true,
            members: cfg.job_details_config && cfg.job_details_config['tab_config.members'] !== undefined ? cfg.job_details_config['tab_config.members'] : true
          },
          conversationConfig: {
            muteButtonEnabled: cfg.job_details_config && cfg.job_details_config['conversation.mute_button.enabled'] !== undefined ? cfg.job_details_config['conversation.mute_button.enabled'] : true
          }
        },
        documentConfig: {
          documentUploadConfirmation: {
            enabled: cfg.document_config && cfg.document_config.document_upload_confirmation && cfg.document_config.document_upload_confirmation.enabled || false,
            text: cfg.document_config && cfg.document_config.document_upload_confirmation && cfg.document_config.document_upload_confirmation.text || ''
          },
          documentEditPermission: cfg.document_config && cfg.document_config.document_edit_permission || null,
          documentStorage: {
            documentStorageService: cfg.document_config && cfg.document_config.document_storage && cfg.document_config.document_storage.document_storage_service || 'Default',
            jacksonHewittStorage: {
              jhSTSPassword: cfg.document_config && cfg.document_config.document_storage && cfg.document_config.document_storage.document_storage_service && cfg.document_config.document_storage.document_storage_service.jackson_hewitt_storage && cfg.document_config.document_storage.document_storage_service.jackson_hewitt_storage.jh_sts_password || '',
              jhSTSUsername: cfg.document_config && cfg.document_config.document_storage && cfg.document_config.document_storage.document_storage_service && cfg.document_config.document_storage.document_storage_service.jackson_hewitt_storage && cfg.document_config.document_storage.document_storage_service.jackson_hewitt_storage.jh_sts_username || '',
              jhSTSServicePath: cfg.document_config && cfg.document_config.document_storage && cfg.document_config.document_storage.document_storage_service && cfg.document_config.document_storage.document_storage_service.jackson_hewitt_storage && cfg.document_config.document_storage.document_storage_service.jackson_hewitt_storage.jh_sts_service_path || '',
              jhEDocsServicePath: cfg.document_config && cfg.document_config.document_storage && cfg.document_config.document_storage.document_storage_service && cfg.document_config.document_storage.document_storage_service.jackson_hewitt_storage && cfg.document_config.document_storage.document_storage_service.jackson_hewitt_storage.jh_edocs_service_path || ''
            }
          }
        },
        callingConfig: {
          enabled: cfg.calling_config && cfg.calling_config.enabled || false
        },
        messageConfig: {
          welcomeMessage: {
            enabled: cfg.message_config && cfg.message_config.welcome_message && cfg.message_config.welcome_message.enabled || false,
            text: cfg.message_config && cfg.message_config.welcome_message && cfg.message_config.welcome_message.text || ''
          }
        },
        mobileWebConfig: {
          appModalDisabled: (_cfg$mobile_web_confi = (_cfg$mobile_web_confi2 = cfg.mobile_web_config) === null || _cfg$mobile_web_confi2 === void 0 ? void 0 : _cfg$mobile_web_confi2.app_modal_disabled) !== null && _cfg$mobile_web_confi !== void 0 ? _cfg$mobile_web_confi : false,
          deepLink: (_cfg$mobile_web_confi3 = (_cfg$mobile_web_confi4 = cfg.mobile_web_config) === null || _cfg$mobile_web_confi4 === void 0 ? void 0 : _cfg$mobile_web_confi4.deep_link) !== null && _cfg$mobile_web_confi3 !== void 0 ? _cfg$mobile_web_confi3 : '',
          allowDeepLink: (_cfg$mobile_web_confi5 = (_cfg$mobile_web_confi6 = cfg.mobile_web_config) === null || _cfg$mobile_web_confi6 === void 0 ? void 0 : _cfg$mobile_web_confi6.allow_deep_linking) !== null && _cfg$mobile_web_confi5 !== void 0 ? _cfg$mobile_web_confi5 : false
        },
        infoGatheringConfig: {
          enabled: (_cfg$information_gath = (_cfg$information_gath2 = cfg.information_gathering_config) === null || _cfg$information_gath2 === void 0 ? void 0 : _cfg$information_gath2.enabled) !== null && _cfg$information_gath !== void 0 ? _cfg$information_gath : false
        },
        notificationsConfig: {
          allowSnoozing: cfg.notifications_config && cfg.notifications_config.allow_snoozing !== undefined ? cfg.notifications_config.allow_snoozing : false,
          JobClosed: cfg.notifications_config && cfg.notifications_config.JobClosed !== undefined ? cfg.notifications_config.JobClosed : true,
          JobReopened: cfg.notifications_config && cfg.notifications_config.JobReopened !== undefined ? cfg.notifications_config.JobReopened : true,
          JobUpdated: cfg.notifications_config && cfg.notifications_config.JobUpdated !== undefined ? cfg.notifications_config.JobUpdated : true,
          MilestoneCompleted: cfg.notifications_config && cfg.notifications_config.MilestoneCompleted !== undefined ? cfg.notifications_config.MilestoneCompleted : true,
          NewJobAvailable: cfg.notifications_config && cfg.notifications_config.NewJobAvailable !== undefined ? cfg.notifications_config.NewJobAvailable : true,
          UnreadMessage: cfg.notifications_config && cfg.notifications_config.UnreadMessage !== undefined ? cfg.notifications_config.UnreadMessage : true,
          UnreadDocument: cfg.notifications_config && cfg.notifications_config.UnreadDocument !== undefined ? cfg.notifications_config.UnreadDocument : true
        },
        roomsConfig: {
          enabled: (_cfg$rooms_config$ena = (_cfg$rooms_config = cfg.rooms_config) === null || _cfg$rooms_config === void 0 ? void 0 : _cfg$rooms_config.enabled) !== null && _cfg$rooms_config$ena !== void 0 ? _cfg$rooms_config$ena : false
        }
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "description", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "slug", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "classification", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "branding", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "domains", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "config", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "customMetadataFields", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isDomainMatchedWorkspace", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "customMetafields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "customMetafields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "corporate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "corporate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isB2B2C", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isB2B2C"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "features", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "features"), _class.prototype), _class);
export { Workspace as default };
//# sourceMappingURL=Workspace.js.map
